import { Path, Rect, Svg, Text, View } from '@react-pdf/renderer'
import { PDF_COLORS } from 'features/reporting/pdfGeneration/constants/colors'
import { PDFStyles } from 'features/reporting/pdfGeneration/styles/PDFStyles'
import React from 'react'

export const KnockoutGeckoLogo = () => (
  <Svg
    id='Layer_2'
    data-name='Layer 2'
    viewBox='0 0 340 340'
    width={40}
    height={40}
    style={{
      justifyContent: 'center',
      alignContent: 'center',
      backgroundColor: PDF_COLORS.TEXT_LIGHT,
    }}>
    <Rect x='2' y='2' width='336' height='336' fill={PDF_COLORS.TEXT_LIGHT} />
    <Rect
      x='2'
      y='2'
      width='336'
      height='336'
      stroke={PDF_COLORS.PRIMARY}
      strokeWidth='4'
    />
    <Path
      fillRule='evenodd'
      d='M23 317V23H317V317H23ZM232.808 112.104V81.5888H217.286C201.456 81.5888 189.93 89.4989 186.533 101.942C179.3 99.0031 171.151 97.1899 162.334 97.1899C131.122 97.1899 107.83 118.908 107.83 148.078C107.83 162.324 113.488 174.986 122.983 184.032C113.259 189.91 107.152 201.665 107.152 213.879C107.152 233.097 121.857 245.988 144.242 245.988H180.197C189.471 245.988 195.798 250.969 196.704 258.431H232.808C232.808 233.186 212.435 214.108 186.533 214.108H150.578C144.471 214.108 140.178 210.711 140.178 205.511C140.178 202.124 141.991 198.956 145.378 196.694C150.807 198.278 156.466 198.956 162.344 198.956C193.556 198.956 217.077 177.238 217.077 148.068C217.077 136.98 213.69 127.256 208.031 119.117C209.167 114.813 213.461 112.104 218.89 112.104H232.808ZM141.772 148.068C141.772 136.761 150.369 128.392 162.354 128.392C174.109 128.392 183.155 136.761 183.155 148.068C183.155 159.375 174.119 167.744 162.354 167.744C150.588 167.744 141.772 159.375 141.772 148.068Z'
      fill={PDF_COLORS.PRIMARY}
    />
  </Svg>
)

interface PageHeaderProps {
  title: string
  topOffset?: number
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  topOffset = 0,
}) => {
  return (
    <View fixed style={[PDFStyles.header, { top: topOffset }]}>
      <View style={PDFStyles.logoContainer}>
        <KnockoutGeckoLogo />
      </View>
      <Text style={PDFStyles.headerTitle}>{title}</Text>
      <View style={PDFStyles.decorationContainer}>
        <View style={PDFStyles.decorativeLongLine} />
        <View style={PDFStyles.decorativeShortLine} />
        <View style={PDFStyles.decorativeMediumLine} />
      </View>
    </View>
  )
}
